import React from 'react'
import AppFooterComponent from '../../@b_components/app_footer/app_footer.component'

const FooterContainer = function ({...props}) {
  return <AppFooterComponent {...props} />
}

export default FooterContainer
